module.exports = __webpack_public_path__ + "img/news18-0.f65cc9ba.png";